import {Disposable, Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {HeartbeatReportLockInput, HeartbeatReportLockMutation} from './__generated__/HeartbeatReportLockMutation.graphql';

// `holder` and `lockedAt` are selected even though a heartbeat usually renews the caller's own lock:
// the one case that matters is the beat that comes back with a DIFFERENT token, which is how this tab
// discovers the lock was taken. Without them that branch writes a null holder over the one the mount
// status read established, so the banner names nobody.
const mutation = graphql`
	mutation HeartbeatReportLockMutation($input: HeartbeatReportLockInput!) {
		heartbeatReportLock(input: $input) {
			token
			locked
			heldByViewer
			holder {
				id
				fullName
				profilePictureId
			}
			lockedAt
			expiresAt
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<HeartbeatReportLockInput>,
	onSuccess?: RelayOnCompleted<HeartbeatReportLockMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
